import { render, staticRenderFns } from "./VentaRemisionPdf.vue?vue&type=template&id=9b1074d8&"
import script from "./VentaRemisionPdf.vue?vue&type=script&lang=js&"
export * from "./VentaRemisionPdf.vue?vue&type=script&lang=js&"
import style0 from "./VentaRemisionPdf.vue?vue&type=style&index=0&id=9b1074d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports